import MarketingImage from '@/components/landing/MarketingImage';
import React from 'react';
const visionIcon = '/images/marketing/landing-vision.svg';
const missionIcon = '/images/marketing/landing-mission.svg';
import styles from './WhyWeExistSection.module.css';

const WhyWeExistSection = () => {
  return (
    <section id="why-we-exist" className={styles.section}>
      <div className={styles.container}>
        <h2 className={styles.heading}>Building the Future of Nutrition</h2>

        <div className={styles.cardGrid}>
          <article className={`${styles.card} ${styles.missionCard}`}>
            <div className={styles.iconWrapper}>
              <MarketingImage loading="lazy" src={missionIcon} alt="" className={styles.iconImage} aria-hidden="true" />
            </div>
            <h3 className={styles.cardTitle}>Our Mission</h3>
            <p className={styles.cardDescription}>
              To empower nutrition practitioners with intelligent, evidence-based technology that
              reduces complexity, enhances clinical workflows, and transforms nutrition science
              into actionable personalised care — helping practitioners deliver better outcomes
              and scale their impact globally.
            </p>
          </article>

          <article className={`${styles.card} ${styles.visionCard}`}>
            <div className={styles.iconWrapper}>
              <MarketingImage loading="lazy" src={visionIcon} alt="" className={styles.iconImage} aria-hidden="true" />
            </div>
            <h3 className={styles.cardTitle}>Our Vision</h3>
            <p className={styles.cardDescription}>
              To become the global nutrition intelligence platform that powers the future of
              personalised health — where practitioners can seamlessly connect data, science, and
              human expertise to deliver precise, evidence-based nutrition care for every individual.
            </p>
          </article>
        </div>
      </div>
    </section>
  );
};

export default WhyWeExistSection;
